const SUPER_ADMIN_USERS = [
  'phong@hirefly.ai',
  'hirefly-admin@hirefly-recruiting.com',
  'lidia@hirefly.ai',
  'hao@hirefly.ai',
  'sameet@hirefly.ai',
  'praveen@hirefly.ai',
  'rohan@hirefly.ai',
  'zona@hirefly.ai',
  'sid@hirefly.ai',
  'adarsh@hirefly.ai',
  'jeremiah@hirefly.ai',
  'pat@hirefly.ai',
  'kyle@hirefly.ai',
  'prabu@hirefly.ai',
  'tim@hirefly.ai',
];
const CANARY_OPT_OUT_USERS = [
  'rohan@hirefly.ai',
  'spencer@hireflyoutreach.com',
  'kyle@hirefly.ai',
  'phong@hirefly.ai',
  'hao@hirefly.ai',
  'sameet@hirefly.ai',
  'sid@hirefly.ai',
  'adarsh@hirefly.ai',
  'pat@hirefly.ai',
  'tim@hirefly.ai',
  'kaiting@hirefly.ai',
  'eric@hirefly.ai',
  'alexandra@hirefly.ai',
];
const FIELDS_LIST = [
  'locations',
  'job_titles',
  'response_prob_val',
  'total_yoe_val',
  'highest_level_edu_val',
  'school_prestige_val',
  'similar_companies_val',
  'industry_match_val',
  'diversity_val',
  'keywords_val',
  'bachelors',
  'phd',
  'mba',
  'advanced_degree',
  'top10_school',
  'ic_or_manager',
  'visa_filter',
  'remote_work_allowed',
  'is_fulltime',
  'comp_target_min',
  'comp_target_max',
  'top25_school',
  'bad_companies',
  'bad_job_titles',
  'bad_keywords',
  'keywords_optional',
  'keywords_required',
  'companies',
  'years_exp_min',
  'years_exp_max',
  'yore_min',
  'job_titles_current_or_past',
  'industries',
  'outreach_templates',
];
const JOB_TITLES = [
  'Software Engineer Project Lead',
  'Assistant System Engineer',
  'Project Development Specialist',
  'Software Quality Assurance Engineer',
  'Account Management Specialist',
  'Dentist',
  'Program Manager Business Development',
  'Sales Engineering Manager',
  'Senior Program Manager',
  'Service Delivery Project Manager',
  'Freelance Web Developer',
  'National Sales Director',
  'Senior Marketing Communications Specialist',
  'Phd Researcher Assistant',
  'Lead Information Technology Project Manager',
  'Marketing Account Executive',
  'Director Marketing Communications',
  'Enterprise Account Executive',
  'National Channel Sales Manager',
  'Director Of Manufacturing Engineering',
  'Software Architect Technical Lead',
  'Advertising Account Manager',
  'National Account Manager',
  'Online Sales Marketing Manager',
  'Electrical System Engineer',
  'Associate Software Quality Assurance Engineer',
  'Director Of Application Engineering',
  'Chief Solutions Architect',
  'Data Engineer',
  'Development Team Specialist',
  'Computer Graphic Designer',
  'Assistant Manager Finance Account',
  'Human Resources Analytics Specialist',
  'Training and Development Specialist',
  'Sales And Marketing Specialist',
  'Student Researcher',
  'Senior Researcher',
  'System Integration Engineer',
  'Associate Recruiter',
  'Lead Solutions Architect',
  'Executive Assistant to General Manager',
  'Junior Oracle Database Administrator',
  'Assistant Brand Manager Marketing',
  'Senior Manager Information Technology Operations',
  'Senior Human Resources Recruiter',
  'Senior Technical Sales Engineer',
  'Executive Assistant Human Resources',
  'Staff Hardware Engineer',
  'Senior Marketing Project Manager',
  'Business Operations Analyst',
  'Product Design Development Specialist',
  'Graduate Student Research Assistant',
  'Senior Executive Administrative Assistant',
  'Software Engineering Manager',
  'Web Designer',
  'Train Driver',
  'Senior Geographic Information System Engineer',
  'System on a Chip Architect',
  'Medical Doctor',
  'Staff Software Engineer',
  'National Sales Training Manager',
  'Driving Instructor',
  'Senior Manager Program Management Office',
  'Financial Planning Analyst',
  'Organizational Development Specialist',
  'Corporate Account Executive',
  'Road Driver',
  'Program Director',
  'Operations Project Manager',
  'Area Sales Director',
  'Senior Manager Corporate Development',
  'Senior Solutions Engineer',
  'Channel Marketing Program Manager',
  'Assistant General Manager Business Development',
  'Senior District Sales Manager',
  'Chief Executive Director',
  'Outside Sales Account Executive',
  'Human Resources Business Partner',
  'Company Driver',
  'Senior Network Operations Engineer',
  'Director Of Operations And Business Development',
  'Mechanical Design Engineer',
  'Deputy Manager Human Resources',
  'Marketing Support Specialist',
  'Devops Manager',
  'Senior Product Development Manager',
  'Marketing And Public Relations Manager',
  'Information Technology Security Specialist',
  'Researcher',
  'Senior Associate Project Manager',
  'Researcher PHD Student',
  'Sales Customer Service Manager',
  'Head of Marketing and Public Relations',
  'Information Technology System Specialist',
  'Electrical Engineering Intern',
  'Resident Doctor',
  'Hardware Design Engineer',
  'Deputy General Manager Human Resources',
  'Manufacturing Engineering Manager',
  'Information Technology System Engineer',
  'Marketing Program Manager',
  'Creative Graphic Designer',
  'Director Of Service Operations',
  'Executive Assistant',
  'Senior Manager Strategic Marketing',
  'Flight Operations Engineer',
  'Regional Key Account Manager',
  'Frontend Engineer',
  'Executive Director Services',
  'Executive Director Human Resources',
  'Technical Director',
  'Doctor Phd',
  'Creative Designer',
  'DevOps Consultant',
  'Fashion Designer',
  'Customer Service Sales Specialist',
  'Assistant Director',
  'Senior Manager Product Strategy',
  'Manager Project Management',
  'Senior Executive Account Manager',
  'Senior System Security Engineer',
  'Driver',
  'Senior Dotnet Developer',
  'Senior National Sales Manager',
  'Assistant Director Of Engineering',
  'Sales Account Specialist',
  'Secretary to Managing Director',
  'Information Technology Service Management Consultant',
  'Graphic User Interface Designer',
  'Senior Operations Project Manager',
  'Assistant to Sales Manager',
  'Regional Trade Marketing Manager',
  'Key Account Manager Retail',
  'Assistant Vice President Human Resources',
  'Director Of Development Operations',
  'Senior Engineering Project Manager',
  'Senior Software Engineer Technical Lead',
  'Special Assistant To Chief Executive Officer',
  'Assistant Vice President Account Executive',
  'Global Product Marketing Manager',
  'Business Development Operations Manager',
  'Senior Presales Engineer',
  'Information Technology Sales Consultant',
  'Human Resources Development Specialist',
  'Principal Electrical Engineer',
  'Global Marketing Communications Manager',
  'Assistant to Project Manager',
  'Electrical Maintenance Engineer',
  'Electronic Data Interchange Specialist',
  'Senior Sql Database Administrator',
  'Data Integration Specialist',
  'Director Of Operations',
  'Data Specialist',
  'Research And Teaching Assistant',
  'Web Content Developer',
  'Construction Project Manager',
  'Information Technology Operations Support Manager',
  'Project Manager Sales Marketing',
  'Principal Software Quality Assurance Engineer',
  'Group Marketing Communications Manager',
  'Project Manager Group Lead',
  'Senior Design Verification Engineer',
  'Product Marketing Manager',
  'Head Of Human Resources',
  'Senior Human Resources Project Manager',
  'System Development Specialist',
  'Freelance Software Engineer',
  'Freelance Graphic Web Designer',
  'Computer Aided Design Designer',
  'Human Resources Assistant',
  'Senior Graphic Designer',
  'Regional Sales Training Manager',
  'Senior Embedded Software Engineer',
  'Assistant Manager Human Resources Development',
  'Research Assistant Professor',
  'Veterinarian',
  'Freelance Graphic Designer',
  'Software Architect Team Lead',
  'Product Development Project Manager',
  'Technical Account Manager',
  'Head Of Product Development',
  'Solutions Architect Team Lead',
  'Assistant General Manager Sales Marketing',
  'Vice President Of Software Engineering',
  'Deputy Executive Director',
  'Information System Security Engineer',
  'Regional Operations Manager',
  'Executive Assistant to Vice President',
  'Principle Software Engineer',
  'Service Marketing Specialist',
  'Key Account Sales Manager',
  'Group Advertising Manager',
  'Assistant Store Manager Operations',
  'Pre Doctoral Fellow',
  'Business Development Management Specialist',
  'Technical Sales Specialist',
  'Media Designer',
  'Commercial Sales Manager',
  'Inside Sales Account Executive',
  'Global Sales Director',
  'Corporate Development Manager',
  'Regional Sales Director',
  'DevOps Engineer',
  'Customer Marketing Specialist',
  'Information Technology Project Consultant',
  'Retail Operations Manager',
  'Product Development Specialist',
  'Account Executive Sales Representative',
  'Corporate Development Specialist',
  'Drafting Design Specialist',
  'Senior Manager Marketing Strategy',
  'Business Development Manager',
  'Head Of Direct Marketing',
  'Technical Sales Engineer',
  'Infrastructure Solutions Architect',
  'Senior Human Resources Business Partner',
  'Sales Account Management Specialist',
  'Electrical Project Engineer',
  'Director of Product Management',
  'Senior Information System Engineer',
  'Lead Software Design Engineer',
  'Senior Engineering Manager',
  'Strategic Account Executive',
  'Graphic Design Specialist',
  'Marketing Advertising Specialist',
  'Senior Quality Assurance Automation Engineer',
  'Hardware Development Engineer',
  'Senior Sales Assistant',
  'Global Product Manager',
  'Executive Director Of Development',
  'Distributed Control System Engineer',
  'Software Automation Engineer',
  'Assistant Manager Sales Marketing',
  'Junior Recruiter',
  'Major Account Sales Manager',
  'Commercial Lines Account Manager',
  'Regional Sales Marketing Manager',
  'Patient Account Specialist',
  'Head of Growth',
  'Key Account Sales Executive',
  'Lead Designer',
  'Consulting Information Technology Specialist',
  'Executive Assistant Human Resources Coordinator',
  'National Account Sales Manager',
  'Design Automation Engineer',
  'Head of Devops',
  'Software System Architect',
  'Assistant to Marketing Director',
  'Senior Manager Strategy Business Development',
  'Senior Software Engineering Manager',
  'Human Resources Recruitment Assistant',
  'Regional Business Development Manager',
  'General Manager Operations',
  'Human Resources Service Center Manager',
  'Senior System Support Engineer',
  'Senior Development Specialist',
  'Sales Support Engineer',
  'Human Resources Administrative Assistant',
  'Advertising Public Relations Specialist',
  'Senior Electrical Engineer',
  'Business Project Manager',
  'Graduate Electrical Engineer',
  'Market Data Specialist',
  'Assistant To Human Resources Director',
  'Corporate Recruiting Specialist',
  'Data Conversion Specialist',
  'Assistant Graphic Designer',
  'Director Business Sales',
  'Human Resources Payroll Assistant',
  'Sales Marketing Operations Manager',
  'Web Design Development Specialist',
  'Information Communication Technology Management Consultant',
  'Associate Software Engineer',
  'Customer Account Manager',
  'Personal Assistant To Chief Executive Officer',
  'Senior Market Researcher',
  'Regional Director Of Operations',
  'Director Corporate Business Development',
  'Senior Application Developer',
  'Data Science Specialist',
  'Database Administrator Team Lead',
  'Product Marketing Specialist',
  'Advertising Public Relations Manager',
  'Senior Hardware Engineer',
  'Global Managing Director',
  'Associate Project Manager',
  'Software Quality Assurance Test Engineer',
  'Senior Technical Product Manager',
  'Online Marketing Specialist',
  'Executive Vice President Corporate Development',
  'Business Program Manager',
  'Managing Director Business Development',
  'Assistant Manager Human Resources',
  'Mixed Signal Design Engineer',
  'Outside Sales Account Manager',
  'Financial Systems Analyst',
  'Senior Information Security Engineer',
  'Assistant Manager Corporate Sales',
  'Head Of Sales Marketing',
  'Information Technology Recruiter',
  'Pharmacist',
  'Head Of Trade Marketing',
  'Instructional Designer',
  'Embedded System Software Engineer',
  'Key Account Management Specialist',
  'Global Marketing Director',
  'Assistant Vice President Sales',
  'Software Architect Project Lead',
  'Senior Software Engineer Contract',
  'Senior Project Program Manager',
  'Assistant Chief Executive',
  'Enterprise Security Architect',
  'Data Scientist',
  'Senior Business Operations Analyst',
  'State Sales Manager',
  'Design Verification Engineer',
  'Director Of Field Operations',
  'Senior Vice President Of Corporate Development',
  '3D Graphic Designer',
  'Information Technology Sales Specialist',
  'Principal Security Engineer',
  'Manager Sales Training Development',
  'Senior Director of Product Management',
  'Senior Advertising Manager',
  'Information Technology Technical Recruiter',
  'Senior System Sales Engineer',
  'Senior Manager Program Management',
  'Enterprise Application Architect',
  'Financial Business Analyst',
  'Assistant to Sales Director',
  'Multimedia Graphic Designer',
  'Business Development Manager National Account',
  'Advertising Media Manager',
  'Regional Sales Service Manager',
  'Principal Solutions Architect',
  'Joint Managing Director',
  'Regional Recruiter',
  'Senior Network Security Engineer',
  'Assistant Director Of Operations',
  'Director Of Network Operations',
  'Commercial Account Executive',
  'Technical Project Manager',
  'Javaee Software Engineer',
  'Senior Commercial Account Manager',
  'Executive Assistant To Vice President Sales',
  'Assistant to Managing Director',
  'Engineering Program Manager',
  'Development Specialist',
  'Presales Support Engineer',
  'Design Engineer',
  'Associate Manager Human Resources',
  'Information Technology Operations Manager',
  'Managing Director Finance',
  'Account Support Specialist',
  'Doctoral Researcher',
  'Principal Technical Account Manager',
  'Sales And Service Specialist',
  'Technical Support Operations Manager',
  'Digital Marketing Specialist',
  'Lead Software System Engineer',
  'Lead Financial Analyst',
  'Chief Software Architect',
  'Firmware Engineer',
  'Senior Staff System Engineer',
  'Clinical Data Management Specialist',
  'Senior Lead System Engineer',
  'Territory Sales Specialist',
  'Senior Frontend Developer',
  'New Business Account Executive',
  'Summer Research Assistant',
  'Office Manager Sales Assistant',
  'Deputy Manager Sales Marketing',
  'National Sales Marketing Manager',
  'Product Line Manager',
  'Senior Director Of Operations',
  'Director Of System Engineering',
  'Information Technology Infrastructure Consultant',
  'Market Development Specialist',
  'Business Account Manager',
  'Operations Program Manager',
  'Business Operations Coordinator',
  'Senior Key Account Manager',
  'Senior Information Technology Specialist',
  'Account Manager Enterprise Sales',
  'Account Manager National Account',
  'Marketing Communications Project Manager',
  'Devops Engineer',
  'Assistant Sales Coordinator',
  'Senior Client Account Manager',
  'Lead Recruiter',
  'Business Account Executive',
  'System Software Engineer',
  'Branch Operations Manager',
  'Analog Design Engineer',
  'Senior Marketing Specialist',
  'Human Resources Manager',
  'Senior Developer',
  'Field Sales Account Manager',
  'Commercial Account Manager',
  'Recruitment Specialist',
  'Corporate Key Account Manager',
  'product manager',
  'Freelance Motion Graphic Designer',
  'Senior Sales Manager',
  'Senior Manager Project Finance',
  'Principal Researcher',
  'Learning And Development Specialist',
  'Human Resources Office Manager',
  'Product Designer',
  'Senior National Account Executive',
  'Information Technology Services Specialist',
  'Strategy Corporate Development',
  'Regional Advertising Manager',
  'Retail Sales Specialist',
  'Information Technology Strategy Consultant',
  'Production Database Administrator',
  'Executive Sales Assistant',
  'Lead Software Architect',
  'Application System Engineer',
  'Sales Operations Assistant',
  'Deputy Managing Director',
  'Senior System Engineer',
  'Senior Public Relations Account Executive',
  'Product Development Engineering Manager',
  'Senior Corporate Account Manager',
  'Sales Administrative Assistant',
  'Web Software Developer',
  'Marketing Sales Support Manager',
  'Senior Information Technology Service Management Consultant',
  'Engineering Manager',
  'Area Sales Manager',
  'Information Technology System Architect',
  'Senior Account Executive',
  'Director Sales Operations',
  'Assistant IT Manager',
  'Assistant Sales Representative',
  'Major Account Specialist',
  'Senior Software Engineer Project Lead',
  'Senior Sap Advanced Business Application Programming Developer',
  'Network Operations Center Engineer',
  'Manager Strategy Corporate Development',
  'Foreign Exchange Specialist',
  'Advertising Sales Manager',
  'Research Project Assistant',
  'Senior Product Project Manager',
  'Network System Architect',
  'Automation Project Engineer',
  'Regional Business Development Specialist',
  'Principle Firmware Engineer',
  'Emergency Medical Services Driver',
  'Marketing Account Specialist',
  'Senior Strategic Account Manager',
  'Junior Design Engineer',
  'Web User Interface Developer',
  'Operations Support System Engineer',
  'Senior Product Marketing Manager',
  'Senior Field Support Engineer',
  'Head of Production Department',
  'Senior Information Technology Program Manager',
  'Executive Recruiting Specialist',
  'Chief System Architect',
  'Transportation Manager',
  'Marketing Account Manager',
  'Customer Project Manager',
  'Executive Assistant to Managing Director',
  'Machine Learning Researcher',
  'International Business Development Manager',
  'Head Human Resources Development',
  'Senior Product Line Manager',
  'International Key Account Manager',
  'Network Design Engineer',
  'Developer',
  'Retail Advertising Manager',
  'Senior Software Architect',
  'General Manager Engineering',
  'Senior Manager Finance Operations',
  'Executive Assistant to Senior Vice President',
  'Data Science Manager',
  'Senior Manager Business Operations',
  'Senior Software Project Manager',
  'Software Engineer Technical Lead',
  'Lead Software Engineer',
  'Director Of Engineering And Operations',
  'Senior Sales Engineer',
  'Sales Marketing Account Executive',
  'Regional Sales Operations Manager',
  'Director Of Information Technology',
  'Legal Researcher',
  'Customer Account Specialist',
  'Chartered Financial Analyst',
  'Information Technology Operations Engineer',
  'Assistant General Manager Sales',
  'Account Executive Business Development Manager',
  'Senior Advanced Business Application Programming Developer',
  'Export Area Sales Manager',
  'Senior Hardware Design Engineer',
  'Engineering Operations Manager',
  'Corporate Business Development',
  'Executive Assistant To Chief Information Officer',
  'Assistant Retail Sales Manager',
  'Senior Software Quality Assurance Analyst',
  'System Sales Engineer',
  'Senior Business Support System Engineer',
  'National Sales Manager',
  'Director Sales Engineering',
  'Regional Sales Manager',
  'Group Human Resources Manager',
  'Assistant Account Manager Private Banking',
  'Senior Vice President of Engineering',
  'Global Solutions Architect',
  'Senior Sap Project Manager',
  'Quality Engineering Manager',
  'Lead Driver',
  'Strategic Development Specialist',
  'Interior Design Specialist',
  'Senior Channel Marketing Manager',
  'Head Of Marketing',
  'Technical Sales Support Engineer',
  'Data Warehouse Engineer',
  'National Sales Operations Manager',
  'Human Resources Shared Services Manager',
  'Car Driver',
  'Interim Human Resources Manager',
  'Head Of Marketing Department',
  'Information Communication Technology Program Manager',
  'Data Network Specialist',
  'Product Project Manager',
  'Account Manager Direct Sales',
  'Product Line Marketing Manager',
  'Graduate Research Assistant',
  'Inside Sales Account Manager',
  'Enterprise Data Architect',
  'Product Design Engineer',
  'Design And Development Engineer',
  'Corporate Sales Account Manager',
  'Director Of Marketing And Public Relations',
  'Associate Director',
  'Senior System Architect',
  'Director of Product Engineering',
  'Associate Doctor',
  'Senior Manager Customer Operations',
  'Doctor Assistant',
  'Chiropractor',
  'Senior Corporate Account Executive',
  'International Sales Director',
  'Senior Software Engineer Team Lead',
  'Network Services Specialist',
  'Sales Management Specialist',
  'Sales Manager Large Account',
  'Hardware Engineering Intern',
  'Deputy General Manager Marketing',
  'Senior Technology Project Manager',
  'Interim Executive Director',
  'Technical Product Manager',
  'National Advertising Manager',
  'Integrated Marketing Communications Manager',
  'Senior Network System Engineer',
  'Lead Data Scientist',
  'Assistant Database Administrator',
  'Sales Project Manager',
  'Head of Media Production',
  'Junior Financial Analyst',
  'Assistant General Manager Marketing',
  'Principal Software Architect',
  'Financial Accounting Analyst',
  'Human Resources Payroll Manager',
  'Area Sales Marketing Manager',
  'General Manager Sales Operations',
  'Principal Software Engineer',
  'New Business Account Manager',
  'Assistant Marketing Manager',
  'Web Design Specialist',
  'Embedded Software Engineer',
  'Operating System Engineer',
  'Program Manager',
  'Director Of Services',
  'Associate System Engineer',
  'Lead Project Manager',
  'Executive Administrative Assistant Office Manager',
  'Senior Business Developer',
  'Senior Manager Special Project',
  'Services Program Manager',
  'Technical Operations Engineer',
  'Senior Manager Corporate Marketing',
  'Information Technology Security Engineer',
  'Sales Director',
  'Delivery Driver',
  'Human Resources Support Specialist',
  'Head of Human Resources Operations',
  'Principal Staff Software Engineer',
  'Sales Manager',
  'System Operations Engineer',
  'Sales Operations Manager',
  'Major Account Sales Executive',
  'Customer Service Operations Manager',
  'Global Product Line Manager',
  'Sales Recruiter',
  'Principal System Engineer',
  'Senior Brand Manager',
  'Lead Principal Software Engineer',
  'Senior Information Technology System Engineer',
  'Public Relations Account Executive',
  'Director Of Sales Marketing',
  'Managing Director Of Operations',
  'Senior Automation Engineer',
  'Supervisory Information Technology Specialist',
  'Senior Research Assistant',
  'Corporate Development Analyst',
  'Talent Acquisition Recruiter',
  'Executive Director Business Development',
  'Human Resources Training Development Manager',
  'Senior Application Database Administrator',
  'Director Of Business Development',
  'Senior Staff Software Engineer',
  'Associate Executive Director',
  'Director Marketing Strategy',
  'Assistant Marketing Director',
  'Senior Lead Software Engineer',
  'Global Human Resources Business Partner',
  'Junior Dotnet Developer',
  'Information Technology Technical Specialist',
  'Interim Human Resources Business Partner',
  'User Interface Designer',
  'Senior Database Administrator',
  'Sales Marketing Administrative Assistant',
  'System-on-Chip Design Engineer',
  'Assistant Executive Director',
  'Information Technology Infrastructure Specialist',
  'Technical Recruiter',
  'Mobile Product Manager',
  'Data Warehousing Specialist',
  'Junior Account Executive',
  'Executive Office Assistant',
  'Assistant Financial Analyst',
  'Head Of Product Management',
  'Senior Program Manager Lead',
  'Web Application Developer',
  'Senior Director Of Engineering',
  'Financial Management Analyst',
  'Data Protection Engineer',
  'Strategic Account Sales Manager',
  'Major Account Executive',
  'Salesperson',
  'Executive Assistant Operations Manager',
  'Marketing Communications Specialist',
  'Senior Regional Human Resources Manager',
  'School Bus Driver',
  'Senior Solutions Architect',
  'Assistant Account Executive',
  'Parts Sales Specialist',
  'Project Manager Sales Operations',
  'Technical Operations Manager',
  'Sales Business Development Manager',
  'Sales Operations Specialist',
  'Assistant Web Developer',
  'Advertising Account Executive',
  'Human Resources Director',
  'Senior Key Account Executive',
  'System Network Security Engineer',
  'Control System Engineer',
  'Vice President Business Operations',
  'Assistant Engineering Manager',
  'Senior System Integration Engineer',
  'Senior Oracle Application Database Administrator',
  'Software Regional Sales Manager',
  'Vice President Corporate Business Development',
  'Junior Project Manager',
  'Senior Financial System Analyst',
  'Project Office Manager',
  'Vice President Enterprise Architecture',
  'New Account Specialist',
  'Parttime Sales Assistant',
  'Project Manager Special Project',
  'Group Product Manager',
  'Doctor Of Physical Therapy',
  'Financial Operations Analyst',
  'Senior Web Developer',
  'Senior Engineering Program Manager',
  'Senior Regional Sales Manager',
  'Hardware Verification Engineer',
  'Information Communication Technology Business Consultant',
  'Marketing Product Development Manager',
  'International Sales Support Specialist',
  'Senior Unix System Engineer',
  'Director Of Process Engineering',
  'Group Sales Marketing Manager',
  'Executive Assistant To Executive Vice President',
  'Dotnet Developer',
  'Associate Marketing Director',
  'Senior Technical Recruiter',
  'Managing Director',
  'Non Executive Director',
  'Software Engineer Team Lead',
  'Area Retail Sales Manager',
  'Executive Director Finance',
  'Assistant Recruiter',
  'Healthcare Recruiter',
  'Account Executive National Account',
  'Business Development Manager Solutions',
  'Field Sales Engineer',
  'Data Integrity Specialist',
  'Director Of Business Operations',
  'Inside Sales Manager',
  'Robotics Engineer',
  'System And Database Administrator',
  'System Developer',
  'Senior Global Marketing Manager',
  'Senior Electrical Engineering',
  'Contract Software Engineer',
  'User Experience Design Specialist',
  'Regional Human Resources Business Partner',
  'Operations Services Manager',
  'Assistant Area Sales Manager',
  'Senior Principal System Engineer',
  'Senior Electrical Design Engineer',
  'National Key Account Manager',
  'Lead Hardware Engineer',
  'Head Graphic Designer',
  'Regional Sales Support Manager',
  'Inside Sales Assistant',
  'Business Operations Manager',
  'International Marketing Specialist',
  'International Sales Marketing Manager',
  'Interactive Media Designer',
  'Senior Corporate Recruiter',
  'Human Resources Specialist',
  'Application Specific Integrated Circuit Design Engineer',
  'DevOps Architect',
  'Account Operations Specialist',
  'Assistant Account Manager',
  'Senior Digital Design Engineer',
  'Human Resources Operations Manager',
  'Senior Staff Electrical Engineer',
  'Information Technology Project Manager',
  'Sales Support Specialist',
  'Online Product Manager',
  'Assistant To The Director Of Operations',
  'Hardware Support Engineer',
  'Vice President Engineering Operations',
  'Associate Researcher',
  'Database Developer',
  'Automation Control Engineer',
  'Engineering Project Manager',
  'Information Technology System Consultant',
  'Director Business Marketing',
  'Social Media Marketing Specialist',
  'Senior Web Application Developer',
  'Sales Development Director',
  'Senior Account Manager Business',
  'Route Driver',
  'User Experience Consultant',
  'Independent Information Technology Consultant',
  'Driver Sales',
  'Head of Product Design',
  'Marketing Development Manager',
  'Marketing Business Development Manager',
  'Senior Sales Marketing Manager',
  'Human Resources Project Specialist',
  'Information Technology Recruitment Consultant',
  'Product Lifecycle Management Manager',
  'Managing Director Sales',
  'Electrical Electronic Engineer',
  'Assistant To The Executive Director',
  'Head Of Marketing Operations',
  'Information Technology Project Management Consultant',
  'Senior Account Manager',
  'Information Technology Technical Consultant',
  'Lead Researcher',
  'Major Account Manager',
  'Director Of Engineering',
  'Project Manager Online Marketing',
  'Architectural Designer',
  'Senior Data Specialist',
  'Plumbing Design Specialist',
  'Corporate Development',
  'Junior Key Account Manager',
  'User Experience Designer',
  'Software Design Engineer in Test',
  'Account Specialist',
  'Human Resources Office Assistant',
  'Network Solutions Architect',
  'Senior Designer',
  'System Support Engineer',
  'Inside Sales Specialist',
  'Product Developer',
  'Key Account Marketing Manager',
  'Senior Financial Operations Analyst',
  'Senior Marketing Program Manager',
  'Executive Assistant Sales Marketing',
  'Network Operations Center Manager',
  'Oracle Database Administrator Team Lead',
  'Head of Human Resources Services',
  'Project Sales Engineer',
  'Frontend Developer',
  'Contract Graphic Designer',
  'Executive Assistant To Chief Operations Officer',
  'Special Event Project Manager',
  'Marketing Research Specialist',
  'Design Production Specialist',
  'PHP Web Developer',
  'Senior Layout Engineer',
  'Sales Marketing Assistant',
  'Program Manager Product Development',
  'Principal Hardware Engineer',
  'Lead Design Engineer',
  'Undergraduate Student Researcher',
  'Pediatrician',
  'Senior Project Manager Contract',
  'Hardware Network Engineer',
  'Senior Project Manager Business Development',
  'Firmware Design Engineer',
  'Lead Software Test Engineer',
  'Executive Creative Director',
  'Senior Manager Product Planning',
  'Head Of Corporate Development',
  'Research Physician',
  'Human Resources Training Manager',
  'Program Office Manager',
  'Senior Construction Project Manager',
  'Senior Java Software Engineer',
  'Information Technology Business Consultant',
  'Trade Marketing Manager',
  'Corporate Account Manager',
  'Head Of Business Operations',
  'Senior Enterprise Architect',
  'Accounts Payable Specialist',
  'Director of Engineering',
  'Executive Assistant Human Resources Manager',
  'Business Operations Associate',
  'Executive Assistant To The Chairman',
  'Associate Financial Analyst',
  'Web Developer Search Engine Optimization',
  'Senior Human Resources Specialist',
  'Software Information Technology Architect',
  'Information Technology Recruitment Specialist',
  'Product Design Development Manager',
  'Freelance Senior Account Manager',
  'Lead Web Developer',
  'Head Of Post Production',
  'Principal Enterprise Architect',
  'Solutions Architect',
  'Financial Data Analyst',
  'Area Sales Engineer',
  'National Account Manager Retail',
  'Marketing Sales Development Manager',
  'Principal Design Engineer',
  'Temporary Human Resources Assistant',
  'Assistant Trade Marketing Manager',
  'Hardware Development Manager',
  'Marketing Communications Public Relations Manager',
  'Senior System Software Engineer',
  'Digital Specialist',
  'Account Executive Sales Manager',
  'Computer Aided Design Engineer',
  'Senior System Test Engineer',
  'Senior Global Project Manager',
  'Assistant Software Engineer',
  'Instructional Design Specialist',
  'Program Management Office Manager',
  'Strategic Account Specialist',
  'Data Management Specialist',
  'Technical Presales Engineer',
  'Business Development Account Manager',
  'Senior Director Business Operations',
  'Marketing Communications Manager',
  'Layout Engineer',
  'Director Strategic Marketing',
  'Motion Graphic Designer',
  'Senior User Experience Consultant',
  'Online Advertising Manager',
  'Senior Manager Marketing Business Development',
  'Deputy General Manager Sales Marketing',
  'Truck Driver',
  'Senior Manager Engineering Operations',
  'Senior Manager New Business Development',
  'Lead Electrical Engineer',
  'Corporate Development Intern',
  'Business Operations Lead',
  'Lead Information Technology Specialist',
  'District Sales Manager',
  'Human Resources Business Development Manager',
  'Data Warehouse Specialist',
  'Senior Recruitment Specialist',
  'International Sales Account Manager',
  'Assistant Managing Director',
  'Senior Physical Design Engineer',
  'Mechanical Electrical Engineer',
  'Java Web Developer',
  'Vice President Senior Account Executive',
  'Technology Development Specialist',
  'Executive Managing Director',
  'Senior Field Marketing Manager',
  'Regional Technical Sales Manager',
  'Co Managing Director',
  'Staffing Recruiter',
  'Assistant Advertising Manager',
  'Advertising Production Manager',
  'Senior Customer Marketing Manager',
  'Information Technology Business Development Manager',
  'Senior Operations Manager',
  'Service Project Manager',
  'Senior Territory Sales Manager',
  'User Experience Manager',
  'Information Technology Operations Project Manager',
  'Product Business Development Manager',
  'Director Corporate Development',
  'Sales Marketing Engineer',
  'Information Technology Network Specialist',
  'Junior Graphic Designer',
  'Development Database Administrator',
  'Lead Electrical and Instrumentation Engineer',
  'Director of Software Development',
  'Small Business Account Manager',
  'Laboratory Research Assistant',
  'Advertising Operations Manager',
  'National Trade Marketing Manager',
  'Advertising Project Manager',
  'Student Research Assistant',
  'Hardware Test Engineer',
  'Senior Account Manager Business Development',
  'Domestic Sales Manager',
  'Information Technology Application Specialist',
  'Creative Director',
  'Advertising And Promotions Manager',
  'Senior Design Specialist',
  'Senior Human Resources Manager',
  'Project Manager Business Development',
  'Enterprise System Architect',
  'Corporate Business Development Manager',
  'National Sales Specialist',
  'Digital Design Engineer',
  'Senior Information Technology Project Manager',
  'Plant Engineering Manager',
  'Assistant Key Account Manager',
  'Hardware Software Design Engineer',
  'Assistant to Marketing Manager',
  'Field Sales Specialist',
  'Software Quality Assurance Manager',
  'Software Quality Assurance Analyst',
  'Senior Business Development Manager',
  'Lead Program Manager',
  'Corporate Recruiter',
  'Human Resources Project Manager',
  'Senior Staff Firmware Engineer',
  'Executive Office Manager',
  'System Engineering Manager',
  'Outside Sales Development Manager',
  'Senior Manager Human Resources Operations',
  'Human Resources Administrative Specialist',
  'Senior Trade Marketing Manager',
  'Cyber Security Engineer',
  'Director Of Marketing Operations',
  'Sales Desk Manager',
  'Strategic Marketing Specialist',
  'Senior Account Manager Team Lead',
  'Talent Acquisition Specialist',
  'Internet Marketing Manager',
  'Key Account Manager',
  'Manager Project Management Office',
  'Network Security Engineer',
  'Regional Channel Sales Manager',
  'Sales Assistant',
  'Information Technology Service Management Specialist',
  'Product Process Development Manager',
  'Senior Control System Engineer',
  'Vice President of Engineering',
  'Graduate Research And Teaching Assistant',
  'Market Research Assistant',
  'Director Of Marketing And Development',
  'Software Design Engineer In Test',
  'Online Marketing Manager',
  'Regional Marketing Communications Manager',
  'General Manager Marketing',
  'Software Architect',
  'Account Manager Sales Marketing',
  'Information System Architect',
  'Senior Software Design Engineer',
  'Senior Director Corporate Development',
  'Software Quality Assurance Tester',
  'Data Center Engineer',
  'Legal Research Assistant',
  'Senior Manager Field Operations',
  'Power System Engineer',
  'Junior Product Manager',
  'Sales Development Manager',
  'Advertising Sales Account Executive',
  'Electrical Design Engineer',
  'Information Technology Specialist',
  'Strategic Business Development Manager',
  'Head Of Strategic Marketing',
  'Operations Support Engineer',
  'Oracle Database Administrator',
  'Assistant Manager Of Product Development',
  'Presales Solutions Architect',
  'Customer Service Project Manager',
  'Visiting Researcher',
  'System Integration And Test Engineer',
  'Technical Solutions Architect',
  'Operations Department Manager',
  'Lead Graphic Designer',
  'Manager Program Management',
  'Sap Human Resources Specialist',
  'Information Technology Program Manager',
  'Field Operations Manager',
  'Marketing Communications Program Manager',
  'Junior Researcher',
  'Group Sales Account Executive',
  'Outside Sales Engineer',
  'Assistant Researcher',
  'Electronic Design Engineer',
  'Senior Information Technology Security Consultant',
  'Information Communication Technology Specialist',
  'Automation System Engineer',
  'Sap Solutions Architect',
  'Electrical Site Engineer',
  'Designer',
  'Deputy General Manager Business Development',
  'Head Of International Marketing',
  'Human Resources Development Assistant',
  'Technical Sales Support Specialist',
  'Mechanical Designer',
  'General Manager Human Resources',
  'Assistant Manager Marketing Communications',
  'Senior Executive Assistant',
  'Financial Director',
  'Assistant To Vice President Sales',
  'Engineering And Maintenance Manager',
  'Senior Software Development Engineer Test',
  'Assistant Director Of Sales Marketing',
  'Senior System Application Engineer',
  'Electrical and Instrumentation Engineer',
  'Applied Scientist',
  'Senior Product Operations Manager',
  'Principal System Architect',
  'Back End Developer',
  'Operations Manager',
  'Digital Marketing Director',
  'Oracle Application Database Administrator',
  'Layout Design Engineer',
  'Software System Test Engineer',
  'Corporate Sales Specialist',
  'Senior Technical Sales Specialist',
  'Senior Regional Account Manager',
  'Design Team Specialist',
  'Lead Oracle Database Administrator',
  'Professional Driver',
  'System Architect',
  'Field Support Engineer',
  'Digital Media Designer',
  'Graphic Designer',
  'Design Specialist',
  'Advertising Services Manager',
  'Lead Enterprise Architect',
  'Managing Director Investment',
  'Senior Training And Development Specialist',
  'Senior Global Product Manager',
  'National Field Sales Manager',
  'Senior Sales Development Manager',
  'Senior Security Engineer',
  'Senior Information Technology Recruiter',
  'Human Resources Business Manager',
  'Chief data scientist',
  'Information Technology Support Consultant',
  'Industrial Design Specialist',
  'Principal Firmware Engineer',
  'Lead Software Quality Assurance Engineer',
  'Data Migration Specialist',
  'Business Operations Consultant',
  'Digital Marketing Manager',
  'Cloud Engineer',
  'Information Technology Consultant',
  'Senior Marketing Manager',
  'Senior Manager Sales Operations',
  'Senior System Engineer Team Lead',
  'Account Manager Corporate Banking',
  'Senior Principal Software Engineer',
  'Assistant Program Manager',
  'Sales Development Specialist',
  'Enterprise Sales Director',
  'International Sales Specialist',
  'Senior Manager Project Management',
  'Solutions Sales Engineer',
  'Information Technology And Services Consultant',
  'Data Processing Specialist',
  'Senior Information Technology Management Consultant',
  'Director Of Hardware Engineering',
  'Freelance Information Technology Consultant',
  'Art Director',
  'Assistant Vice President Sales Marketing',
  'Senior Information Technology Consultant',
  'Global Key Account Manager',
  'Head Of Online Marketing',
  'Operations Support System Manager',
  'Senior Graphic Web Designer',
  'Assistant Director Of Sales',
  'Enterprise Information Architect',
  'Student Web Developer',
  'Android Developer',
  'Information Technology Solutions Consultant',
  'Senior Manager Product Engineering',
  'Data Entry Specialist',
  'Director Of Finance And Operations',
  'Emarketing Manager',
  'Director Of Sales And Business Development',
  'Customer Sales Specialist',
  'Senior Electrical Project Engineer',
  'Embedded System Engineer',
  'International Product Marketing Manager',
  'National Retail Sales Manager',
  'Project Lead Developer',
  'Landscape Design Specialist',
  'Pre Doctoral Intern',
  'Senior Business Project Manager',
  'Marketing Specialist',
  'Key Account Project Manager',
  'Product Manager',
  'Medical Transport Driver',
  'Advertising Specialist',
  'Network Operations Manager',
  'Head Of Production',
  'Assistant Sales Manager',
  'Manager of Sales',
  'Head of Product Operations',
  'Security Solutions Architect',
  'Graphic Web Designer',
  'Fashion Design Specialist',
  'Project Designer',
  'Senior Product Manager',
  'Technical Program Manager',
  'Product Development Manager',
  'Chief Data Scientist',
  'National Strategic Account Manager',
  'Product Engineering Manager',
  'Global Marketing Specialist',
  'Clinical Research Assistant',
  'Associate Director Of Operations',
  'Senior Financial Analyst',
  'Floral Design Specialist',
  'Head Of Product Marketing',
  'System Engineer Team Lead',
  'Corporate Development Officer',
  'Office Manager Marketing Assistant',
  'General Manager of Sales',
  'Associate Product Marketing Manager',
  'Account Development Specialist',
  'Research And Development Assistant',
  'Postgraduate Researcher',
  'Quantitative Researcher',
  'Crane Operator',
  'Territory Account Manager',
  'Policy Researcher',
  'Technology Business Development Manager',
  'Global Account Manager',
  'Director Strategy Corporate Development',
  'Group Managing Director',
  'User Experience Engineer',
  'Associate Director Of Sales',
  'System Test Engineer',
  'Business Operations',
  'Lead System Architect',
  'Director Of Technology Operations',
  'Interior Designer',
  'Big Data Developer',
  'Research And Development Specialist',
  'Worldwide Product Marketing Manager',
  'Business Support System Engineering',
  'Global Account Specialist',
  'Assistant Regional Sales Manager',
  'Postdoctoral Researcher',
  'Senior Network Operations Center Engineer',
  'Principal Sales Engineer',
  'Director Of Marketing And Product Management',
  'Sales Operations Planning Manager',
  'Information Technology Support Specialist',
  'Corporate Human Resources Manager',
  'Doctoral Intern',
  'Vice President Operations Business Development',
  'Assistant Human Resources Officer',
  'Key Account Sales Specialist',
  'Autonomous Systems Engineer',
  'Field Marketing Specialist',
  'Senior Manager Marketing Operations',
  'Sales Associate Assistant Manager',
  'Sales Service Manager',
  'Inside Sales Engineer',
  'Research Assistant Intern',
  'line chef',
  'Sales Specialist',
  'Forklift Operator',
  'Regional Sales Account Manager',
  'Head Of Customer Marketing',
  'Director Of Design Engineering',
  'Corporate Marketing Communications Manager',
  'National Account Sales Executive',
  'Senior Manager Network Operations',
  'Project Design Engineer',
  'Devops Architect',
  'Junior Web Developer',
  'Network And Database Administrator',
  'System Security Engineer',
  'Head of DevOps',
  'Retail Sales Assistant',
  'Assistant Manager Accounts Payable',
  'Head Of Marketing Services',
  'Technical Project Program Manager',
  'Managing Director Marketing',
  'Junior Electrical Engineer',
  'Peoplesoft Database Administrator',
  'Business Development Key Account Manager',
  'Hardware System Engineer',
  'Data Communications Engineer',
  'Hardware Design Manager',
  'National Account Project Manager',
  'Data Mining Specialist',
  'Staff Firmware Engineer',
  'Sales Product Development Manager',
  'Assistant General Manager Project',
  'Business Intelligence Solutions Architect',
  'Planning Development Specialist',
  'Manager Product Management',
  'Sales Marketing Manager',
  'Senior Data Engineer',
  'Java Software Engineer',
  'Computer Hardware Engineer',
  'Research Development Hardware Engineer',
  'Business Development Specialist',
  'Senior Project Manager',
  'Marketing Operations Manager',
  'Lead Information System Engineer',
  'Assistant General Manager Operations',
  'Head Of Brand Marketing',
  'Senior Managing Director',
  'Information Technology Program Management Office Manager',
  'Human Resources Organization Development Manager',
  'Hardware Manager',
  'Information Technology Solutions Architect',
  'Senior Enterprise Account Manager',
  'Advertising Manager',
  'Senior Firmware Engineer',
  'Regional Corporate Sales Manager',
  'Sales Support Assistant',
  'Electrical Field Engineer',
  'Product Sales Marketing Manager',
  'Technical Talent Acquisition Specialist',
  'Design Development Specialist',
  'Cloud Support Engineer',
  'Director Marketing Services',
  'Senior Sales Account Executive',
  'Human Resources Development Manager',
  'Enterprise Solutions Architect',
  'Security Engineer',
  'Senior Business Solutions Architect',
  'System Engineer',
  'Senior Major Account Executive',
  'Senior Software Engineer',
  'Sap Human Resources Project Manager',
  'National Account Executive',
  'Head Of Marketing Business Development',
  'Business Development Account Executive',
  'Assistant It Manager',
  'Data Network Engineer',
  'Embedded Design Engineer',
  'Network System Engineer',
  'Market Researcher',
  'Head Of Corporate Marketing',
  'Software Design Engineer',
  'Business Operations Specialist',
  'Business Unit Human Resources Manager',
  'General Manager Sales Marketing',
  'Executive Director Marketing',
  'Operating Engineer',
  'System-on-chip Design Engineer',
  'Senior Business Intelligence Developer',
  'Project Lead Account Manager',
  'Software Engineer',
  'Client Account Manager',
  'Senior Financial Reporting Analyst',
  'Regional Sales Engineer',
  'Senior Manager User Experience',
  'Area Sales Specialist',
  'Lead Dotnet Developer',
  'System Architect Team Lead',
  'Driver Warehouse',
  'Assistant Product Marketing Manager',
  'Senior Digital Designer',
  'Physical Design Engineer',
  'Marketing And Advertising Manager',
  'Deputy Director Of Operations',
  'Medical Researcher',
  'Executive Assistant To Chief Executive Officer',
  'Executive Director Of Operations',
  'iOS Developer',
  'Group Product Marketing Manager',
  'Sales Operations Support Specialist',
  'Web System Developer',
  'Head Of Retail Marketing',
  'Lead Database Administrator',
  'Global Human Resources Manager',
  'Senior Operations Program Manager',
  'Senior Major Account Manager',
  'Senior Financial Planning Analyst',
  'Senior User Experience Designer',
  'Software Developer In Test',
  'Sales Account Manager',
  'Marketing Director',
  'Field Operations Engineer',
  'Global Strategic Account Manager',
  'Oracle Sql Server Database Administrator',
  'Structural Design Engineer',
  'Executive Sales Director',
  'Senior National Account Manager',
  'Principal Database Administrator',
  'Technical Recruiting Specialist',
  'Senior Business Financial Analyst',
  'Deputy Program Manager',
  'Service Operations Manager',
  'Director of Product Marketing',
  'Executive Assistant Office Manager',
  'Strategy Business Development Manager',
  'Regional Account Executive',
  'Web Developer',
  'Enterprise Account Manager',
  'Junior Software Engineer',
  'Administrative Assistant To Chief Executive Officer',
  'Senior Analog Design Engineer',
  'Senior Manager Finance Account',
  'Machine Learning Engineer',
  'Summer Researcher',
  'General Sales Manager',
  'Clinical Data Specialist',
  'National Business Development Manager',
  'Head Of Global Marketing',
  'Account Services Specialist',
  'Sales Development Representative',
  'Advertisement Sales Specialist',
  'Business System Architect',
  'Senior Manager Corporate Human Resources',
  'Firmware Architect',
  'Assistant Operations Manager',
  'Regional Human Resources Manager',
  'Senior Information Technology Business Consultant',
  'Finance Account Specialist',
  'Account Director',
  'Senior Account Project Manager',
  'Corporate Development Associate',
  'Sql Database Administrator',
  'DevOps Manager',
  'Customer Support Operations Manager',
  'Global Program Manager',
  'Data Mining Engineer',
  'Contract Web Developer',
  'Senior Manager Human Resources Information System',
  'Senior Software Support Engineer',
  'Recruiter',
  'Senior Sales Engineer',
  'Junior Database Administrator',
  'International Sales Manager',
  'Global Marketing Manager',
  'Marketing Project Manager',
  'Process Engineering Manager',
  'Key Account Manager Automotive',
  'Senior Service Account Manager',
  'Emarketing Specialist',
  'Information Technology Management Consultant',
  'Information Technology Operations Specialist',
  'Global Sales Marketing Manager',
  'Executive Assistant Manager',
  'Human Resources Recruiting Specialist',
  'Senior Vice President Business Operations',
  'Associate Product Manager',
  'Senior Mechanical Design Engineer',
  'Software Development Engineer Test Lead',
  'Portfolio Marketing Manager',
  'Executive Account Manager',
  'Frontend Web Developer',
  'Marketing Manager',
  'Regional Head of Human Resources',
  'Senior Event Marketing Manager',
  'Senior Manager Technical Operations',
  'Application Engineering Manager',
  'System Design Engineer',
  'Senior Talent Acquisition Specialist',
  'Business Intelligence Program Manager',
  'Account Service Executive',
  'Senior Design Engineer',
  'Project Researcher Specialist',
  'Sales Service Engineer',
  'Information Technolology Manager',
  'Corporate Sales Marketing Manager',
  'Senior Area Sales Manager',
  'Financial Services Analyst',
  'Regional Marketing Manager',
  'Process Automation Engineer',
  'Summer Financial Analyst',
  'Director Of Marketing And Business Development',
  'Senior Oracle Database Administrator',
  'Vice President of Software Engineering',
  'Director Of Development',
  'Executive Project Assistant',
  'Computer Aided Design Software Engineer',
  'Program Project Manager',
  'Assistant Project Manager',
  'Senior Manager Human Resources Development',
  'Special Project Manager',
  'Research Project Lead',
  'Director Channel Sales',
  'Enterprise Architecture Manager',
  'Student Assistant',
  'New Media Designer',
  'Product Manager Products',
  'Customer Solutions Architect',
  'Vice President Strategy Corporate Development',
  'Information Technology Security Consultant',
  'Program Financial Analyst',
  'Director Of Technical Operations',
  'Senior Manager Sales Business Development',
  'Executive Finance Account',
  'Executive Assistant Project Manager',
  'Retail Salesperson',
  'Human Resources Management Assistant',
  'Radiologist',
  'Executive Assistant To The President',
  'Senior Data Scientist',
  'Hardware Project Manager',
  'Senior Marketing Communications Manager',
  'Art Direction Design Specialist',
  'Senior Global Account Manager',
  'Senior System Design Engineer',
  'Services Business Development Manager',
  'Channel Sales Account Manager',
  'Freelance Designer',
  'Director Of Retail Operations',
  'General Manager Business Development',
  'Human Resources Services Specialist',
  'Senior Sales Director',
  'Deputy General Manager Of Sales',
  'Project Manager Team Lead',
  'Information Technology Solutions Specialist',
  'Assistant Manager Business Development',
  'Business Development Operations Specialist',
  'Computer Specialist',
  'Software Firmware Engineer',
  'Enterprise Information Technology Architect',
  'Senior Data Warehouse Engineer',
  'Senior Software Quality Assurance Manager',
  'Financial Reporting Analyst',
  'Hardware Engineering Manager',
  'Engineering Services Manager',
  'Vice President Of Engineering',
  'Senior Software Engineer Research Development',
  'Software Solutions Architect',
  'Corporate Sales Account Executive',
  'Executive Assistant To Chief Financial Officer',
  'Head Of Marketing Communications',
  'Regional Account Manager',
  'Senior Manager Clinical Operations',
  'Human Resources Information System Specialist',
  'Hardware Engineer',
  'Senior Technical Project Manager',
  'Strategic Account Manager',
  'Territory Sales Manager',
  'System Engineer Project Lead',
  'Senior Technical Program Manager',
  'Food Service Sales Manager',
  'Retail Sales Manager',
  'Senior Software Test Engineer',
  'Assistant Manager Sales Operations',
  'Senior Human Resources Assistant',
  'Executive Recruiter',
  'Marketing And Public Relations Specialist',
  'Information Technology Web Developer',
  'Principal Program Manager',
  'Electrical Engineer',
  'Global Account Sales Manager',
  'Hardware Software Engineer',
  'Marketing Graphic Designer',
  'Quality Assurance Automation Engineer',
  'Executive Personal Assistant',
  'Research Development Product Manager',
  'Senior Vice President Engineering Operations',
  'Key Account Executive',
  'Electrical Engineering Specialist',
  'Software Support Engineer',
  'Database Administrator',
  'Regional Managing Director',
  'Undergraduate Research Assistant',
  'Optometrist',
  'Major Account District Manager',
  'Senior Data Network Engineer',
  'Project Manager Technical Lead',
  'Technical Sales Account Manager',
  'Line Chef',
  'Electrical Control Engineer',
  'Senior Application Specific Integrated Circuit Design Engineer',
  'Financial Analyst',
  'Lead Security Engineer',
  'Trade Marketing Specialist',
  'Senior Information Technology Recruitment Consultant',
  'Senior Electrical and Instrumentation Engineer',
  'Director Of Program Operations',
  'Chief Enterprise Architect',
  'Human Resources Services Manager',
  'Senior Director Of Marketing',
  'Security Software Engineer',
  'Lead System Engineer',
  'Senior Sales Application Engineer',
  'Executive Manager Human Resources',
  'Automation Engineer',
  'Data Communications Specialist',
  'Co Executive Director',
  'Engineering Department Manager',
  'Corporate Training Manager',
  'Sales Account Executive',
  'Marketing Management Specialist',
  'PHP Developer',
  'Executive Director',
  'Enterprise Architecture Consultant',
  'Assistant Product Manager',
  'Business Support System Engineer',
  'Network Operations Engineer',
  'Regional Product Marketing Manager',
  'Senior Manager Human Resources Administrative',
  'Classified Advertising Manager',
  'Senior Clinical Project Manager',
  'Project Manager Technical Support',
  'Head Of Digital Marketing',
  'Brand Advertising Manager',
  'Enterprise Architect',
  'Computer Aided Design Specialist',
  'Director Of Mechanical Engineering',
  'Sales Application Engineer',
  'System Engineering Team Lead',
  'Senior Software Quality Assurance Engineer',
  'Senior Manager of Product Management',
  'Global Business Development Manager',
  'Program Developer',
  'New Product Development Manager',
  'Assistant General Manager Human Resources',
  'Head of Product',
  'Graduate Student Researcher',
  'Assistant Director Of Human Resources',
  'Sales Engineer',
  'Devops Consultant',
  'General Practitioner',
  'Graphic Designer Production',
  'Director Enterprise Architecture',
  'Director Of Electrical Engineering',
  'Research And Administrative Assistant',
  'Executive Administrative Assistant',
  'Software Test Engineer',
  'Group Manager Product Development',
  'Senior Vice President Of Engineering',
  'Associate Information Technology Consultant',
  'Account Manager',
  'Web Development Specialist',
  'Senior Technical Account Manager',
  'Senior Online Marketing Manager',
  'Information Security Engineer',
  'Volunteer Research Assistant',
  'Operations Support Manager',
  'Doctoral Student',
  'Account Executive',
  'Senior Manager Marketing Services',
  'Senior Operations Engineer',
  'Business Solutions Architect',
  'Lead Automation Engineer',
  'Senior Manager System Engineering',
  'Group Key Account Manager',
  'Corporate Account Specialist',
  'Director Of Corporate Sales',
  'Human Resources Operations Specialist',
  'Contract Recruiter',
  'Senior International Product Manager',
  'Human Resources Accounting Assistant',
  'Senior Sales Account Manager',
  'Services Account Executive',
  'Regional Marketing Director',
  'Operations Engineer',
  'Data System Engineer',
  'Personal Assistant to Managing Director',
  'Doctor',
  'Project Manager',
  'Digital Designer',
  'Research Assistant',
  'Information Technology Program Project Manager',
  'SAP Business Analyst',
  'National Account Specialist',
  'Assistant To Chief Executive Officer',
  'Assistant Electrical Engineer',
  'Director Of Software Development',
  'Application Developer',
  'Package Handler',
  'Director',
  'Vice President Corporate Development',
  'Business Intelligence Developer',
  'New Business Development Manager',
  'Human Resources Assistant Intern',
  'Head Of Software Development',
  'Software Engineer',
  'Visual Merchandising Manager',
  'Merchandising Manager',
  'Email Marketing Manager',
  'Customer Experience Manager',
];

const SHORT_JOB_TITLES = [
  'Data Engineer',
  'Automation Engineer',
  'Back End Developer',
  'Senior Automation Engineer',
  'Sales Development Representative',
  'Software Engineer',
  'Frontend Engineer',
  'Frontend Developer',
  'Senior Frontend Developer',
  'Senior Software Engineer',
  'Principle Software Engineer',
  'Software Engineering Manager',
  'Senior Software Engineering Manager',
  'Staff Software Engineer',
  'Director of Software Development',
  'Director of Product Management',
  'Director of Engineering',
  'Vice President of Engineering',
  'Senior Vice President of Engineering',
  'Vice President of Software Engineering',
  'Software Test Engineer',
  'Software Design Engineer in Test',
  'Senior Software Development Engineer Test',
  'Firmware Engineer',
  'Senior Firmware Engineer',
  'Principle Firmware Engineer',
  'Staff Firmware Engineer',
  'Senior Staff Firmware Engineer',
  'Firmware Architect',
  'Software Quality Assurance Engineer',
  'Software Quality Assurance Analyst',
  'Software Quality Assurance Manager',
  'Software Quality Assurance Tester',
  'Devops Engineer',
  'Devops Consultant',
  'Devops Architect',
  'Devops Manager',
  'Database Administrator',
  'Head of Devops',
  'Head of Growth',
  'Head of Product',
  'Applied Scientist',
  'Data Scientist',
  'Data Science Manager',
  'Chief Data Scientist',
  'Senior Data Scientist',
  'Machine Learning Engineer',
  'Machine Learning Researcher',
  'System Engineer',
  'Senior System Engineer',
  'System Engineering Manager',
  'Autonomous Systems Engineer',
  'Security Engineer',
  'Senior Security Engineer',
  'Network Security Engineer',
  'User Experience Engineer',
  'User Experience Designer',
  'User Experience Manager',
  'User Experience Consultant',
  'Solutions Architect',
  'Software Architect',
  'System Architect',
  'Enterprise Architect',
  'Product Manager',
  'Senior Product Manager',
  'Product Marketing Manager',
  'Product Development Manager',
  'Assistant Product Manager',
  'Project Manager',
  'Technical Project Manager',
  'Technical Program Manager',
  'Group Product Manager',
  'Operations Manager',
  'Operations Engineer',
  'Program Manager',
  'Business Development Manager',
  'Business Development Specialist',
  'Sales Specialist',
  'Sales Manager',
  'Sales Assistant',
  'Sales Engineer',
  'Senior Sales Engineer',
  'Technical Sales Specialist',
  'Account Manager',
  'Account Executive',
  'Account Specialist',
  'Marketing Specialist',
  'Marketing Manager',
  'Sales Marketing Manager',
  'Human Resources Specialist',
  'Human Resources Manager',
  'Human Resources Assistant',
  'Executive Assistant',
  'Assistant IT Manager',
  'Information Technology Specialist',
  'Information Technolology Manager',
  'Information Technology Consultant',
  'Hardware Engineer',
  'Senior Hardware Engineer',
  'Hardware Manager',
  'Electrical Engineer',
  'Senior Electrical Engineer',
  'Analog Design Engineer',
  'Mixed Signal Design Engineer',
  'Digital Designer',
  'Design Verification Engineer',
  'Layout Engineer',
  'Digital Design Engineer',
  'Senior Digital Design Engineer',
  'Senior Design Verification Engineer',
  'Physical Design Engineer',
  'Senior Physical Design Engineer',
  'System-on-chip Design Engineer',
  'Researcher',
  'Senior Researcher',
  'Advertising Manager',
  'Advertising Specialist',
  'Financial Analyst',
  'Business Operations',
  'Corporate Development',
];

const LOCATIONS = [
  'United States',
  'Remote - United States',
  'Alabama, United States',
  'Greater Birmingham Area',
  'Alaska, United States',
  'Greater Anchorage Area',
  'Arizona, United States',
  'Greater Phoenix Area',
  'Greater Tucson Area',
  'Arkansas, United States',
  'Little Rock Metropolitan Area',
  'California, United States',
  'Metropolitan Fresno',
  'Los Angeles Metropolitan Area',
  'San Diego Metropolitan Area',
  'Orange County, California, United States',
  'Greater Sacramento',
  'Greater Salinas Area',
  'San Francisco Bay Area',
  'Santa Barbara-Santa Maria Area',
  'Stockton, California, United States',
  'Colorado, United States',
  'Greater Colorado Springs Area',
  'Greater Fort Collins Area',
  'Denver Metropolitan Area',
  'Connecticut, United States',
  'Greater Hartford',
  'New London County, Connecticut, United States',
  'Delaware, United States',
  'District of Columbia, United States',
  'Washington DC-Baltimore Area',
  'Florida, United States',
  'Daytona Beach, Florida, United States',
  'Fort Myers, Florida, United States',
  'Fort Pierce, Florida, United States',
  'Gainesville Metropolitan Area',
  'Lakeland, Florida, United States',
  'Melbourne, Florida, United States',
  'Miami-Fort Lauderdale Area',
  'Greater Orlando',
  'Sarasota, Florida, United States',
  'Greater Tampa Bay Area',
  'West Palm Beach, Florida, United States',
  'Georgia, United States',
  'Atlanta Metropolitan Area',
  'Metro Jacksonville',
  'Tallahassee Metroplitan Area',
  'Hawaii, United States',
  'Idaho, United States',
  'Boise Metropolitan Area',
  'Illinois, United States',
  'Greater Chicago Area',
  'Peoria, Metropolitan Area',
  'Urbana-Champaign Area',
  'Indiana, United States',
  'Greater Evansville Area',
  'Greater Indianapolis',
  'Iowa, United States',
  'Kansas, United States',
  'Wichita, Kansas Metropolitan Area',
  'Kentucky, United States',
  'Greater Lexington Area',
  'Louisville Metropolitan Area',
  'Louisiana, United States',
  'Maine, United States',
  'Portland, Maine Metropolitan Area',
  'Maryland, United States',
  'Massachusetts, United States',
  'Greater Boston',
  'Michigan, United States',
  'Greater Fort Wayne',
  'Detroit Metropolitan Area',
  'Grand Rapids Metropolitan Area',
  'Greater Kalamazoo Area',
  'Greater Lansing',
  'Greater Saginaw-Midland-Bay City Area',
  'Minnesota, United States',
  'Greater Minneapolis-St. Paul Area',
  'Mississippi, United States',
  'Baton Rouge Metropolitan Area',
  'Greater New Orleans Region',
  'Greater Jackson Area',
  'Mobile, Alabama Area',
  'Missouri, United States',
  'Columbia, Missouri, United States',
  'Davenport, Iowa, United States',
  'Des Moines Metropolitan Area',
  'Greater Fayetteville, AR Area',
  'Greater St. Louis',
  'Kansas City, Missouri, United States',
  'Springfield, Missouri, United States',
  'Montana, United States',
  'Nebraska, United States',
  'Omaha Metropolitan Area',
  'Lincoln, Nebraska Metropolitan Area',
  'Nevada, United States',
  'Las Vegas Metropolitan Area',
  'Greater Reno Area',
  'New Hampshire, United States',
  'New Jersey, United States',
  'New Mexico, United States',
  'Albuquerque-Santa Fe Metropolitan Area',
  'New York, United States',
  'Albany, New York Metropolitan Area',
  'Buffalo-Niagara Falls Area',
  'New York City Metropolitan Area',
  'Rochester, New York Metropolitan Area',
  'Syracuse, New York, United States',
  'North Carolina, United States',
  'Charlotte Metro',
  'Raleigh-Durham-chapel hill Area',
  'Greater Wilmington Area',
  'North Dakota, United States',
  'Ohio, United States',
  'Cincinnati Metropolitan Area',
  'Greater Cleveland',
  'Columbus, Ohio Area',
  'Dayton Metropolitan Area',
  'Toledo, Ohio Metropolitan Area',
  'Oklahoma, United States',
  'Oklahoma City Metropolitan Area',
  'Tulsa Metropolitan Area',
  'Oregon, United States',
  'Greater Eugene-Springfield Area',
  'Portland, Oregon Metropolitan Area',
  'Pennsylvania, United States',
  'Allentown, Pennsylvania, United States',
  'Greater Philadelphia',
  'Greater Pittsburgh Region',
  'Greater Harrisburg Area',
  'Ithaca, New York, United States',
  'Lancaster Metropolitan Area',
  'Greater Scranton Area',
  'Rhode Island, United States',
  'Providence, Rhode Island, United States',
  'South Carolina, United States',
  'Augusta, Georgia, United States',
  'Charleston, South Carolina Metropolitan Area',
  'Columbia, South Carolina Metropolitan Area',
  'Greenville-Spartanburg-Anderson, South Carolina Area, United States',
  'Greater Savannah Area',
  'South Dakota, United States',
  'Sioux Falls, South Dakota, United States',
  'Tennessee, United States',
  'Greater Asheville',
  'Chattanooga, Tennessee Area',
  'Memphis Metropolitan Area',
  'Nashville Metropolitan Area',
  'Huntsville, Alabama, United States',
  'Johnson City-Kingsport-Bristol Area',
  'Knoxville Metropolitan Area',
  'Texas, United States',
  'Austin, Texas Metropolitan Area',
  'Dallas-Fort Worth Metroplex',
  'El Paso Metropolitan Area',
  'Greater Houston',
  'San Antonio, Texas Metropolitan Area',
  'Utah, United States',
  'Salt Lake City Metropolitan Area',
  'Provo, Utah, United States',
  'Vermont, United States',
  'Burlington, Vermont, United States',
  'Springfield, Massachusetts Metropolitan Area',
  'Virginia, United States',
  'Greater Charlottesville Area',
  'Greensboro--Winston-Salem--High Point Area',
  'Norfolk, Virginia, United States',
  'Richmond, Virginia, United States',
  'Greater Roanoke Area',
  'Washington, United States',
  'Greater Seattle Area',
  "Spokane-Coeur d'Alene Area",
  'West Virginia, United States',
  'Wisconsin, United States',
  'Greater Milwaukee',
  'Green Bay, Wisconsin Metropolitan Area',
  'Greater Madison Area',
  'Appleton-Oshkosh-Neenah Area',
  'Greater Rockford Area',
  'Wyoming, United States',
  'Greater Bengaluru Area',
  'Tel Aviv District, Israel',
  'Greater Tokyo Area',
  'Greater Delhi Area',
  'Greater Chennai Area',
  'Greater Hyderabad Area',
  'Mumbai Metroplitan Region',
  'Pune/Pimpri-Chinchwad Area',
  'India',
  'Remote - Global',
];

const ETHNICITIES = [
  'No Preference',
  'Native American',
  'Asian',
  'Black/African American',
  'Hispanic/Latino',
  'White',
  'Pacific Islander',
];

const PUBLIC_BOOKING_URL = 'https://schedule.nylas.com/';

// const INDUSTRIES = [
//   { id: 1, name: 'Sports' },
//   { id: 1, name: 'Services' },
//   { id: 1, name: 'Consumer Goods' },
//   { id: 1, name: 'Energy/Environment/Agro' },
//   { id: 1, name: 'Real Estate' },
//   { id: 1, name: 'Hardware' },
//   { id: 1, name: 'Business' },
//   { id: 1, name: 'Nonprofit' },
//   { id: 1, name: 'Media/Design' },
//   { id: 1, name: 'Manufacturing/Logistics' },
//   { id: 1, name: 'Legal' },
//   { id: 1, name: 'Government' },
//   { id: 1, name: 'Business or Finance' },
//   { id: 1, name: 'Healthcare' },
//   { id: 1, name: 'Software ' },
//   { id: 1, name: 'Education' },
//   { id: 1, name: 'Mechanical' },
//   { id: 1, name: 'Software' },
// ];
const INDUSTRIES = [
  'Sports',
  'Services',
  'Consumer Goods',
  'Energy/Environment/Agro',
  'Real Estate',
  'Hardware',
  'Business',
  'Nonprofit',
  'Media/Design',
  'Manufacturing/Logistics',
  'Legal',
  'Government',
  'Business or Finance',
  'Healthcare',
  'Software',
  'Education',
  'Mechanical',
];

const INDUSTRIES_OLD = [
  { id: 1, name: 'Fine Art' },
  { id: 1, name: 'Biotechnology' },
  { id: 1, name: 'Consumer Goods' },
  { id: 1, name: 'Aviation & Aerospace' },
  { id: 1, name: 'Computer Software' },
  { id: 1, name: 'Wholesale' },
  { id: 1, name: 'Wine and Spirits' },
  { id: 1, name: 'Alternative Medicine' },
  { id: 1, name: 'Philanthropy' },
  { id: 1, name: 'Outsourcing/Offshoring' },
  { id: 1, name: 'Professional Training & Coaching' },
  { id: 1, name: 'Environmental Services' },
  { id: 1, name: 'Internet' },
  { id: 1, name: 'Tobacco' },
  { id: 1, name: 'Motion Pictures and Film' },
  { id: 1, name: 'Farming' },
  { id: 1, name: 'Import and Export' },
  { id: 1, name: 'Glass, Ceramics & Concrete' },
  { id: 1, name: 'Higher Education' },
  { id: 1, name: 'Consumer Services' },
  { id: 1, name: 'E-Learning' },
  { id: 1, name: 'Construction' },
  { id: 1, name: 'Public Policy' },
  { id: 1, name: 'Facilities Services' },
  { id: 1, name: 'Medical Devices' },
  { id: 1, name: 'Civil Engineering' },
  { id: 1, name: 'Food & Beverages' },
  { id: 1, name: 'Religious Institutions' },
  { id: 1, name: 'Political Organization' },
  { id: 1, name: 'Oil & Energy' },
  { id: 1, name: 'Museums and Institutions' },
  { id: 1, name: 'Individual & Family Services' },
  { id: 1, name: 'Restaurants' },
  { id: 1, name: 'Logistics and Supply Chain' },
  { id: 1, name: 'Law Practice' },
  { id: 1, name: 'Education Management' },
  { id: 1, name: 'Fund-Raising' },
  { id: 1, name: 'Leisure, Travel & Tourism' },
  { id: 1, name: 'Management Consulting' },
  { id: 1, name: 'Paper & Forest Products' },
  { id: 1, name: 'Nonprofit Organization Management' },
  { id: 1, name: 'Venture Capital & Private Equity' },
  { id: 1, name: 'Airlines/Aviation' },
  { id: 1, name: 'Apparel & Fashion' },
  { id: 1, name: 'Online Media' },
  { id: 1, name: 'Machinery' },
  { id: 1, name: 'Research' },
  { id: 1, name: 'Mental Health Care' },
  { id: 1, name: 'Recreational Facilities and Services' },
  { id: 1, name: 'Health, Wellness and Fitness' },
  { id: 1, name: 'Libraries' },
  { id: 1, name: 'Food Production' },
  { id: 1, name: 'Architecture & Planning' },
  { id: 1, name: 'Mobile Games' },
  { id: 1, name: 'International Trade and Development' },
  { id: 1, name: 'Investment Management' },
  { id: 1, name: 'Public Safety' },
  { id: 1, name: 'Package/Freight Delivery' },
  { id: 1, name: 'Electrical/Electronic Manufacturing' },
  { id: 1, name: 'Gambling & Casinos' },
  { id: 1, name: 'Hospital & Health Care' },
  { id: 1, name: 'Design' },
  { id: 1, name: 'Industrial Automation' },
  { id: 1, name: 'Retail' },
  { id: 1, name: 'Animation' },
  { id: 1, name: 'Human Resources' },
  { id: 1, name: 'Graphic Design' },
  { id: 1, name: 'Photography' },
  { id: 1, name: 'Defense & Space' },
  { id: 1, name: 'Wireless' },
  { id: 1, name: 'Warehousing' },
  { id: 1, name: 'Media Production' },
  { id: 1, name: 'Veterinary' },
  { id: 1, name: 'Capital Markets' },
  { id: 1, name: 'Computer Hardware' },
  { id: 1, name: 'Writing and Editing' },
  { id: 1, name: 'Think Tanks' },
  { id: 1, name: 'Publishing' },
  { id: 1, name: 'Plastics' },
  { id: 1, name: 'Government Administration' },
  { id: 1, name: 'Marketing and Advertising' },
  { id: 1, name: 'Packaging and Containers' },
  { id: 1, name: 'Legislative Office' },
  { id: 1, name: 'Market Research' },
  { id: 1, name: 'Shipbuilding' },
  { id: 1, name: 'Maritime' },
  { id: 1, name: 'Banking' },
  { id: 1, name: 'Furniture' },
  { id: 1, name: 'Utilities' },
  { id: 1, name: 'Consumer Electronics' },
  { id: 1, name: 'Semiconductors' },
  { id: 1, name: 'Real Estate' },
  { id: 1, name: 'Events Services' },
  { id: 1, name: 'Commercial Real Estate' },
  { id: 1, name: 'Staffing and Recruiting' },
  { id: 1, name: 'Newspapers' },
  { id: 1, name: 'Broadcast Media' },
  { id: 1, name: 'Dairy' },
  { id: 1, name: 'Renewables & Environment' },
  { id: 1, name: 'Judiciary' },
  { id: 1, name: 'Computer Games' },
  { id: 1, name: 'Entertainment' },
  { id: 1, name: 'Financial Services' },
  { id: 1, name: 'Performing Arts' },
  { id: 1, name: 'Information Technology and Services' },
  { id: 1, name: 'Computer Networking' },
  { id: 1, name: 'Program Development' },
  { id: 1, name: 'Mining & Metals' },
  { id: 1, name: 'Music' },
  { id: 1, name: 'Hospitality' },
  { id: 1, name: 'Public Relations and Communications' },
  { id: 1, name: 'Chemicals' },
  { id: 1, name: 'Sporting Goods' },
  { id: 1, name: 'Telecommunications' },
  { id: 1, name: 'Mechanical or Industrial Engineering' },
  { id: 1, name: 'Transportation/Trucking/Railroad' },
  { id: 1, name: 'Law Enforcement' },
  { id: 1, name: 'Cosmetics' },
  { id: 1, name: 'Supermarkets' },
  { id: 1, name: 'Textiles' },
  { id: 1, name: 'Primary/Secondary Education' },
  { id: 1, name: 'Information Services' },
  { id: 1, name: 'Printing' },
  { id: 1, name: 'Medical Practice' },
  { id: 1, name: 'Luxury Goods & Jewelry' },
  { id: 1, name: 'Accounting' },
  { id: 1, name: 'Railroad Manufacture' },
  { id: 1, name: 'International Affairs' },
  { id: 1, name: 'Pharmaceuticals' },
  { id: 1, name: 'Executive Office' },
  { id: 1, name: 'Building Materials' },
  { id: 1, name: 'Nanotechnology' },
  { id: 1, name: 'Sports' },
  { id: 1, name: 'Business Supplies and Equipment' },
  { id: 1, name: 'Civic & Social Organization' },
  { id: 1, name: 'Translation and Localization' },
  { id: 1, name: 'Computer & Network Security' },
  { id: 1, name: 'Insurance' },
  { id: 1, name: 'Investment Banking' },
  { id: 1, name: 'Government Relations' },
  { id: 1, name: 'Military' },
  { id: 1, name: 'Automotive' },
  { id: 1, name: 'Arts and Crafts' },
  { id: 1, name: 'Legal Services' },
  { id: 1, name: 'Security and Investigations' },
];

const RECRUITER_PROFILE_USERS = [
  'megha@sigmacomputing.com',
  'megha.a@sigmacomputing.com',
  'neha@sigmacomputing.com',
  'colleen@sigmacomputing.com',
  'colleen@sigmacomputing.hirefly.ai',
  'megha@sigmacomputing.hirefly.ai',
];

const USED_COLORS = [
  'blue',
  'red',
  'teal',
  'purple',
  'orange',
  'blueGrey',
  'brown',
  'cyan',
  'deepOrange',
  'deepPurple',
  'green',
  'indigo',
  'amber',
  'lightGreen',
  'lightBlue',
  'pink',
];

const USED_CHILDREN_COLORS = [
  'base',
  'darken1',
  'darken2',
  'darken3',
  'darken4',
  'darken5',
  'accent1',
  'accent2',
  'accent3',
  'accent4',
];

const OPERATIONS_STATUS = {
  backlog: ['Critical', 'Backlog', '#CA3D3D'],
  slow_pace: ['Critical', 'Slow Pace', '#CA3D3D'],
  hm_approval: ['Critical', 'Approval Rate', '#CA3D3D'],
  narrow: ['Critical', 'Narrow', '#CA3D3D'],
  new: ['New', 'To - Do', '#1DA1F2'],
  new_review: ['New', 'For Review', '#1DA1F2'],
  client_delay: ['Delays', 'By Client', '#F2C211'],
  free_trial: ['Free Trials', 'Active', '#4F46E5'],
  free_trial_debrief: ['Free Trials', 'Debreif', '#4F46E5'],
  self_serve: ['Self Serve', 'Self Serve', '#4F46E5'],
  borderline: ['Borderline', 'Borderline', '#F2991D'],
  healthy: ['Healthy', 'Healthy', '#37B797'],
  paused: ['Paused', 'Paused', '#FFFFFF'],
};

const TABS_V1_TO_V2_MAP = {
  WARM_LEADS_HM: 'HIRING_MANAGER',
  WARM_LEADS_QUESTION: 'QUESTION',
  WARM_LEADS_HM_APPROVED: 'HIRING_MANAGER_APPROVED',
  INTERVIEWING: 'INTERVIEWING',
  CONTACTED: 'CONTACTED',
  WARM_LEADS_AWAITING_INFO: 'AWAITING_INFO',
  REJECTED: 'REJECTED',
  NOT_INTERESTED: 'NOT_INTERESTED',
  WARM_LEADS_RECRUITER: 'AUTOPILOT_RECRUITER',
  APPROVED: 'APPROVED',
  UNDER_REVIEW: 'UNDER_REVIEW',
};

const AUTOPILOT_SIGN =
  '<p style="margin:0px;padding:0px"><br></p><p style="margin:0px;padding:0px"><br></p><p style="margin:0px;padding:0px">Thanks,</p><p style="margin:0px;padding:0px">Rohan Nagesh</p><p style="margin:0px;padding:0px">Co-founder and CEO</p><p style="margin:0px;padding:0px">Hirefly</p>';

const productTypes = {
  AUTOPILOT: 'autopilot',
  FAST_TRACK: 'fasttrack',
  NAVIGATOR: 'navigator',
};

export const ATS_STATUS = {
  INCOMPLETE: 'INCOMPLETE',
  COMPLETE: 'COMPLETE',
  RELINK_NEEDED: 'RELINK_NEEDED',
  ACTIVE: 'ACTIVE',
  INVALID: 'INVALID',
  INACTIVE: 'INACTIVE',
  UNKNOWN: 'UNKNOWN',
};

export default {
  SUPER_ADMIN_USERS,
  JOB_TITLES,
  LOCATIONS,
  ETHNICITIES,
  PUBLIC_BOOKING_URL,
  INDUSTRIES,
  RECRUITER_PROFILE_USERS,
  CANARY_OPT_OUT_USERS,
  FIELDS_LIST,
  USED_COLORS,
  USED_CHILDREN_COLORS,
  OPERATIONS_STATUS,
  TABS_V1_TO_V2_MAP,
  AUTOPILOT_SIGN,
  productTypes,
};
